import {
  CORE_LOAD_ALL_BUILDING_REQUEST,
  CORE_LOAD_ALL_BUILDING_SUCCESS,
  CORE_LOAD_ALL_BUILDING_FAILURE
} from '../types'
const requestState = 'request'
  , initialState = []
// , initialStateObj = {}
export default {
  buildings: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_BUILDING_REQUEST:
        return requestState
      case CORE_LOAD_ALL_BUILDING_SUCCESS:
        let result = []
        if (result && Array.isArray(action.payload)) {
          result = action.payload
        }
        return result
      case CORE_LOAD_ALL_BUILDING_FAILURE:
        return initialState
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerBuilding.js